export const uploadConfig = {
  onboardingUploaderConfig: {
    maxFiles: 1,
    maxFileSize: 5 * 1024 * 1024,
    acceptedTypes: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
  },
};

export const avatarUploaderConfig = {
  maxFiles: 1,
  maxFileSize: 5 * 1024 * 1024,
  acceptedTypes: [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/PNG',
    'image/JPEG',
    'image/JPG',
  ],
};
